import { z } from "zod";

export const DocumentCatalogViewSchema = z.enum([
  "all",
  "attention",
  "correction",
  "drafts",
  "approval",
  "processing",
  "approved",
  "archived",
  "history",
]);

export const DocumentCatalogQuerySchema = z.object({
  limit: z.number().int().min(1).max(100).default(25),
  offset: z.number().int().min(0).max(100_000).default(0),
  q: z.string().trim().max(200).default(""),
  partnerId: z.string().trim().min(1).max(128).optional(),
  year: z.number().int().min(1900).max(9999).optional(),
  view: DocumentCatalogViewSchema.default("all"),
  direction: z.enum(["ALL", "INBOUND", "OUTBOUND", "UNKNOWN"]).default("ALL"),
  type: z
    .enum(["ALL", "INVOICE", "CREDIT_NOTE", "DEBIT_NOTE", "DUNNING", "OTHER"])
    .default("ALL"),
  sort: z.enum(["updated_desc", "updated_asc"]).default("updated_desc"),
});

export type DocumentCatalogQuery = z.infer<typeof DocumentCatalogQuerySchema>;

export const DocumentCatalogPaginationSchema = z.object({
  limit: z.number().int().min(1).max(100),
  offset: z.number().int().min(0).max(100_000),
  total: z.number().int().nonnegative(),
  hasMore: z.boolean(),
});
